import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function LogoutPage() {
  const { logout, sessionError } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const loginState = useRef({
    authError: location.state?.authError || sessionError,
    from: location.state?.from,
  });

  useEffect(() => {
    logout();
    navigate('/login', { replace: true, state: loginState.current });
  }, [logout, navigate]);

  return null;
}

export default LogoutPage;
